namespace Gamification.Gamification {
    export interface UtentiProdottiEsperienzeDashboardForm {
        IdUtenteProdotto: Serenity.IntegerEditor;
        IdProdottoEsperienza: Serenity.IntegerEditor;
        IdProdottoEsperienzaNome: Serenity.StringEditor;
        MigliorePunteggio: Serenity.IntegerEditor;
        MigliorePunteggioData: Serenity.DateEditor;
        PeggiorePunteggio: Serenity.IntegerEditor;
        PeggiorePunteggioData: Serenity.DateEditor;
        UltimoPunteggio: Serenity.IntegerEditor;
        UltimoPunteggioData: Serenity.DateEditor;
        MiglioreIdUtenteProdottoEsperienza: Serenity.IntegerEditor;
        PeggioreIdUtenteProdottoEsperienza: Serenity.IntegerEditor;
        UltimoIdUtenteProdottoEsperienza: Serenity.IntegerEditor;
    }

    export class UtentiProdottiEsperienzeDashboardForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiProdottiEsperienzeDashboard';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiProdottiEsperienzeDashboardForm.init)  {
                UtentiProdottiEsperienzeDashboardForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;

                Q.initFormType(UtentiProdottiEsperienzeDashboardForm, [
                    'IdUtenteProdotto', w0,
                    'IdProdottoEsperienza', w0,
                    'IdProdottoEsperienzaNome', w1,
                    'MigliorePunteggio', w0,
                    'MigliorePunteggioData', w2,
                    'PeggiorePunteggio', w0,
                    'PeggiorePunteggioData', w2,
                    'UltimoPunteggio', w0,
                    'UltimoPunteggioData', w2,
                    'MiglioreIdUtenteProdottoEsperienza', w0,
                    'PeggioreIdUtenteProdottoEsperienza', w0,
                    'UltimoIdUtenteProdottoEsperienza', w0
                ]);
            }
        }
    }
}
